import './date-picker.scss'

import { FormApi } from 'final-form';
import { get, set } from 'lodash'
import { DateTime } from 'luxon'
import { defineComponent } from 'vue';

import { DATE_FORMATS, buildSkinDateWithFormat, toFormat } from '@skinsoft/utils'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'

export const DatePicker = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['form', 'name', 'readOnly'],
    template: require('./date-picker.html'),
    mounted() {
        // Filling date picker with value
        const defaultValue = get(this.form.getState().values, this.name)
        if (defaultValue && defaultValue.skinIntervalComplexes?.[0]?.startInterval?.date) {
            this.dateValue = toFormat(defaultValue, DATE_FORMATS.YYYY_MM_DD_DASH)
        } else {
            // If reportDate is blank, set today's date
            this.dateValue = DateTime.now().toFormat(DATE_FORMATS.YYYY_MM_DD_DASH);
        }
    },
    computed: {
        dateValue: {
            get(): string {
                return toFormat(get(this.form.getState().values, this.name), DATE_FORMATS.YYYY_MM_DD_DASH)
            },
            set(value: string) {
                set(this.form.getState().values, this.name, this.toSkinDate(value))
            },
        },
    },
    methods: {
        /**
         * Generates a date suitable for backend data from the
         * date-picker value
         */
        toSkinDate(dateString: string) {
            return buildSkinDateWithFormat(dateString, DATE_FORMATS.YYYY_MM_DD_DASH);
        },
        getDateFormatOptions() {
            return {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            }
        },
    },
})
